import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalFooterProps {
    children: ReactNode;
    className?: string;
}

export const ResponsiveModalFooter = (props: IResponsiveModalFooterProps) => {
    const {children, className} = props;
    const footerRef = useResponsiveModalPartRef("footer");

    return (
        <div ref={footerRef} className={classNames(styles.footer, className)}>
            {children}
        </div>
    );
};
import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalFooterProps {
    children: ReactNode;
    className?: string;
}

export const ResponsiveModalFooter = (props: IResponsiveModalFooterProps) => {
    const {children, className} = props;
    const footerRef = useResponsiveModalPartRef("footer");

    return (
        <div ref={footerRef} className={classNames(styles.footer, className)}>
            {children}
        </div>
    );
};
